/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Step_PlanInputs */

const cs_auth_signup_step_plan = /** @type {(inputs: Auth_Signup_Step_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif`)
};

const en_auth_signup_step_plan = /** @type {(inputs: Auth_Signup_Step_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Auth_Signup_Step_PlanInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_step_plan = /** @type {((inputs?: Auth_Signup_Step_PlanInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Step_PlanInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_step_plan(inputs)
	return cs_auth_signup_step_plan(inputs)
});